export function getReceiptMail({
  amount,
  transactionId,
  balance,
  studentInfo,
  studentId,
  receiptId,
  schoolName
}: {
  amount: string;
  transactionId: string;
  balance: string;
  studentInfo: string;
  studentId: string;
  receiptId: string;
  schoolName: string;
}): string {
  return `<!DOCTYPE html>
<html>
  <body style="margin:0; padding:0; font-family:Arial, sans-serif; font-size:14px; color:#000; background-color:#fff;">
    <div style="width:800px; margin:0 auto; padding:24px; border:1px solid #000; background:#fff;">
      <!-- Logo -->
      <img src="https://europreschool.com/wp-content/uploads/2025/07/logo.jpeg" alt="Logo" height="70" width="70" />
      <!-- Header -->
      <div style="text-align:center; border-bottom:1px solid #000; padding-bottom:16px;">
        <h2 style="font-size:20px; font-weight:600; margin:0;">${schoolName}</h2>
        <p style="font-size:14px; max-width:40ch; margin:8px auto 0;">
          Plot No 4, Sushila Nagar, Rajiv Gandhi Salai, OMR, Opposite to KFC, Tiruporur Tk, Kelambakkam, Chennai 603103
        </p>
      </div>
      <!-- Transaction Info -->
      <table width="100%" style="border-collapse:collapse; text-align:center; border-bottom:1px solid #000; margin-top:16px;">
        <thead>
          <tr style="font-weight:bold;">
            <td style="padding:8px;">AMOUNT</td>
            <td style="padding:8px;">TRANSACTION ID</td>
            <td style="padding:8px;">BALANCE</td>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td style="padding:8px;">${amount}</td>
            <td style="padding:8px;">${transactionId}</td>
            <td style="padding:8px;">${balance}</td>
          </tr>
        </tbody>
      </table>
      <!-- Student Info -->
      <div style="border-bottom:1px solid #000; padding:16px 0;">
        <p style="font-weight:bold; margin:0 0 8px 0;">Student Info</p>
        <div style="padding-left:16px; white-space:pre-line;">${studentInfo}</div>
        ${studentId ? `<div style=\"padding-left:16px; font-size:12px; color:gray;\">Student Registration No: ${studentId}</div>` : ''}
      </div>
      <!-- Footer -->
      <div style="padding-top:48px; display:flex; justify-content:space-between;">
        <table width="100%" style="margin-top:16px;">
          <tr>
            <td style="font-weight:500;">Receipt id: ${receiptId}</td>
          </tr>
        </table>
      </div>
    </div>
  </body>
</html>`;
}
export function generateFeesReminderMail({
    studentName,
    registerId,
    paidAmount,
    pendingAmount,
    dueDate,
    schoolName = 'Euro Wis Kids Preschool',
  }: {
    studentName: string;
    registerId: string;
    paidAmount: string;
    pendingAmount: string;
    dueDate: string;
    schoolName?: string;
  }): string {
    return `
    <!DOCTYPE html>
    <html>
      <body style="margin:0; padding:0; font-family:Arial, sans-serif; font-size:14px; color:#000; background-color:#fff;">
        <div style="width:800px; margin:0 auto; padding:24px; border:1px solid #000; background:#fff;">
          
          <!-- Logo -->
          <img src="https://europreschool.com/wp-content/uploads/2025/07/logo.jpeg" alt="Logo" height="70" width="70" />
  
          <!-- Header -->
          <div style="text-align:center; border-bottom:1px solid #000; padding-bottom:16px;">
            <h2 style="font-size:20px; font-weight:600; margin:0;">${schoolName}</h2>
            <p style="font-size:14px; max-width:40ch; margin:8px auto 0;">
              Plot No 4, Sushila Nagar, Rajiv Gandhi Salai, OMR, Opposite to KFC, Tiruporur Tk, Kelambakkam, Chennai 603103
            </p>
          </div>
  
          <!-- Body -->
          <div style="padding-top:24px;">
            <p>Dear Parent,</p>
            <p>This is a gentle reminder regarding the pending school fees for your child:</p>
  
            <table style="width:100%; margin-top:16px; border-collapse:collapse;">
              <tr>
                <td style="padding:8px 0; font-weight:bold;">Student Name:</td>
                <td>${studentName}</td>
              </tr>
              <tr>
                <td style="padding:8px 0; font-weight:bold;">Register ID:</td>
                <td>${registerId}</td>
              </tr>
              <tr>
                <td style="padding:8px 0; font-weight:bold;">Fees Already Paid:</td>
                <td>₹${paidAmount}</td>
              </tr>
              <tr>
                <td style="padding:8px 0; font-weight:bold;">Due Date:</td>
                <td>${dueDate}</td>
              </tr>
            </table>
  
            <div style="margin-top:24px; text-align:center;">
              <h2 style="margin:0; color:red;">Pending Amount: ₹${pendingAmount}</h2>
            </div>
  
            <p style="margin-top:24px;">Please make the payment before the due date to avoid any late fees.</p>
  
            <p style="margin-top:24px;">Thank you,<br/>Administration<br/>${schoolName}</p>
          </div>
        </div>
      </body>
    </html>
    `;
  }